
export default [
    {
        title: 'Mon agenda',
        icon: 'CalendarIcon',
        route: 'calendrier',
        typeUser: 'courtier',
    }
]
